import { apiClient, apiClientScanette } from "../../../config";

export type LoginDTO = {
    clientId: string;
    username: string;
    password: string;
};

export async function login(
    request: LoginDTO,
): Promise<{ token: string; apiUrl: string; apiUrlScanette: string }> {
    const { clientId, username, password } = request;

    const response = await apiClientScanette.get<{ url_web_service_client: string }>(
        `https://webservice.lagenza.fr/action.php`,
        {
            params: {
                action: "connexion",
                client_id: clientId,
                login: username,
                mdp: password,
            },
        },
    );

    const parsedUrl = new URL(response.data.url_web_service_client);
    const apiUrl = `${parsedUrl.origin}/resaApi`;

    const { data } = await apiClient.post<{ token: string }>(`${apiUrl}/api/login`, {
        login: username,
        password,
    });

    return {
        token: data.token,
        apiUrl,
        apiUrlScanette: response.data.url_web_service_client,
    };
}
